import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import {
    ContactUserTokenFilterParams,
    SingleTestMessageSettingModel,
} from '../../models/contact_notification_token';

import API from '../../services/api';

import testMessageSettingUserKeys from './_querykeys';

const getSingleTestMessageUser = async (
    filterParams?: ContactUserTokenFilterParams,
) => {
    const { data } = await API.getSingleTestMessageSettingUser(filterParams);
    return data as SingleTestMessageSettingModel[];
};

export default function useGetSingleTestMessageUser(
    filterParams?: ContactUserTokenFilterParams,
    enabled?: boolean,
) {
    return useQuery<SingleTestMessageSettingModel[], BaseError>({
        queryKey:
            testMessageSettingUserKeys.filteredSingleTestMessageUser(
                filterParams,
            ),
        queryFn: () => getSingleTestMessageUser(filterParams),
        enabled,
    });
}
